import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const styles = theme => ({
	root: {
		width: '100%',
	},
	button: {
		marginRight: 10,
	},
	instructions: {
		marginTop: 10,
		marginBottom: 10,
	},
	stepper : {
		paddingTop :5
	}
});

function getSteps() {
	return ['テンプレートの選択・読込', '設定紐付', '初期設定', '確認・完了'];
}

class stepper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep:false
		}
	}

	render() {
		const {classes,activeStep} = this.props;
		const steps = getSteps();

		return (
			<div className={classes.root}>
				<Stepper className={classes.stepper} activeStep={activeStep}>
					{steps.map((label, index) => {
						const stepProps = {};
						const labelProps = {};
						return (
							<Step key={label} {...stepProps}>
								<StepLabel {...labelProps}>{label}</StepLabel>
							</Step>
						);
					})}
				</Stepper>
			</div>
		);
	}
}
stepper.propTypes = {
	activeStep:PropTypes.number,
};
stepper.defaultProps = {
	activeStep:0
};

export default withStyles(styles)(stepper);


// WEBPACK FOOTER //
// ./src/routes/mapping/components/stepper.js